<script setup>
import { useRouter } from "vue-router";

import AppMenuItem from "./AppMenuItem.vue";
import { useLayout } from "./composables/layout";

const { onConfigSidebarToggle } = useLayout();

const router = useRouter();

defineProps({
  topModel: {
    type: Array,
    default: null,
  },
  bottomModel: {
    type: Array,
    default: null,
  },
});

const navigateToCreate = () => {
  onConfigSidebarToggle();
  router.push("/create");
};
</script>

<template>
  <ul class="layout-menu flex flex-col h-full justify-start">
    <div class="flex items-center justify-center">
      <Button
        label="Automate"
        icon="pi pi-bolt"
        :pt="{
          label: '!font-semibold pl-1.5 pr-1.5',
          icon: '!text-xl pr-0.5',
          button: '!hover:bg-neena-red-400',
        }"
        outlined
        class="flex w-[92%] h-10 !pl-0 !border-neena-red-400 !bg-neena-red-400 !bg-opacity-10 !text-neena-red-400 hover:!bg-opacity-20"
        @click="navigateToCreate"
      ></Button>
    </div>
    <template v-for="(item, i) in topModel" :key="item">
      <AppMenuItem :item="item" root :index="i" />
      <li class="menu-separator"></li>
    </template>
    <div class="flex-grow"></div>
    <template v-for="(item, i) in bottomModel" :key="item">
      <AppMenuItem :item="item" root :index="i" />
    </template>
    <div class="pb-2"></div>
  </ul>
</template>
